import React from 'react';
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import styles from "../css/Exhibition.module.css";
import {Link} from "react-router-dom";
import Button from "../../components/inputs/Button";
import {setSequence} from "../../service/util/setSequence";


const ExhibitionDnd = ({ invalidFalse, onDeleted, setRoomList }) => {
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        setRoomList((item) => setSequence(item, result.source.index, result.destination.index));
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={"exhibitionList"}>
                {(provided, snapshot) => (
                    <div
                        style={{ width: "100%" }}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {invalidFalse.map((room, index) => {
                            return (
                                <Draggable key={"exhibitionList" + index} draggableId={"exhibitionList" + index} index={index}>
                                    {provided => (
                                        <li
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <input type={"hidden"} value={room.id} />
                                            <span>[ <b>{room.seq + 1}</b> ]</span>
                                            <div className={styles.exhImg}>
                                                <img alt={room.imageAltText} src={room.imageUrl} />
                                            </div>
                                            <div className={styles.exhRoomInfo}>
                                                <h5 className={"ellipsis1"} style={{ width: "100%" }}>{room.roomNo}</h5>
                                                <h4 className={"ellipsis1"} style={{ width: "100%" }}>{room.name}</h4>
                                                <span className={"ellipsis3"} style={{ wordWrap: "break-word", wordBreak : "break-all" }}>{room.introduction}</span>
                                            </div>
                                            <Link to={`/setting/exhibition/${room.id}`}>
                                                <Button style={{ background: "#DFA78F" }}>수정</Button>
                                            </Link>
                                            <Button onClick={() => onDeleted(room.id)} style={{ background: "#D55240" }}>삭제</Button>
                                        </li>
                                    )}
                                </Draggable>
                            )
                        })}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default ExhibitionDnd;